import { deleteRequest, getRequest, patchRequest, postRequest } from "./ApiRequest";

// Prodotti della carta diversi dal vino (piatti, birre, cocktail, distillati, mixer).
// Risposte {success, message, data}.
const M = "menucard";
export const GetMenuItemsAPI = () => getRequest(`${M}/dishes`);
export const AddMenuItemAPI = (formData) => postRequest(`${M}/dishes`, formData);
export const UpdateMenuItemAPI = (id, payload) => patchRequest(`${M}/dishes/${id}`, payload);
export const DeleteMenuItemAPI = (id) => deleteRequest(`${M}/dishes/${id}`);
export const SearchBeverageCatalogAPI = (q, section) =>
  getRequest(`${M}/beverages/search?q=${encodeURIComponent(q)}&section=${section}`);
export const AddFromBeverageCatalogAPI = (payload) => postRequest(`${M}/beverages`, payload);

// Esaurito / nascosto: vale per i prodotti inseriti a mano (quelli di CassaInCloud si aggiornano dalla cassa).
export const SetManualProductAvailableAPI = (isWine, id, isAvailable) =>
  patchRequest(`${M}/${isWine ? "wines" : "dishes"}/${id}`, { is_available: isAvailable });
